import { useCallback, memo } from "react";

import { EmbeddedVideoPlayer } from "../EmbeddedVideoPlayer";
import { useSfw } from "@/common/hooks/useSfw";
import { apiMain } from "@/common/services";
import { useFetch } from "@/common/hooks/useFetch";

interface PlayerWrapperProps {
  id: string;
}

export const PlayerWrapper = memo((props: PlayerWrapperProps) => {
  const { sanitizeUser, sanitizeGif, isLoading: sfwLoading } = useSfw();

  const fetchGif = useCallback(() => apiMain.fetchGifById(props.id), [props.id]);
  const { data: info, isLoading, error } = useFetch(fetchGif);

  if (info) {
    const user = info.user ? sanitizeUser(info.user) : null;
    const { gif } = sanitizeGif(info.gif);

    return <EmbeddedVideoPlayer
      gif={gif}
      id={gif.id}
      userName={user?.name || user?.username}
      userId={user?.username}
      userPic={user?.profileImageUrl ?? undefined}
      verified={!!user?.verified}
      isStudio={!!user?.studio}
      sdVideo={gif.urls.sd}
      hdVideo={gif.urls.hd}
      poster={gif.urls.thumbnail}
      sound={!!gif.hasAudio}
    />;
  }

  if (isLoading || sfwLoading) {
    return <div className="embedPage">
      <p className="message">Loading...</p>
    </div>;
  }

  if (error) {
    return <div className="embedPage">
      <p className="error message">Error loading this gif.</p>
    </div>;
  }

  return null;
});
